import React, { useMemo } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import styled from "styled-components";

import { State } from "src/state/ducks";
import { BakedBreadEntity } from "src/firebase/db/BakedBreads";
import { NotificationTemplateEntity } from "src/firebase/db/NotificationTemplates";

import StyleConfig from "src/constants/StyleConfig";
import { formatDate } from "src/helpers/UtilityHelper";

import Button from "src/components/atoms/button/Button";
import NotificationTemplateConfirmBakedBread from "src/components/organisms/form/NotificationTemplateConfirmBakedBread";

type Props = {
  notificationTemplate: NotificationTemplateEntity;
  bakedBreads: BakedBreadEntity[];
  onBack: (payload: NotificationTemplateEntity) => void;
  onSubmit: (payload: NotificationTemplateEntity) => void;
};

const NotificationTemplateConfirmForm = (props: Props) => {
  const { notificationTemplate, bakedBreads, onSubmit, onBack } = props;
  const {
    id,
    name,
    pickup_supplement,
    scheduled_time,
    can_order_time,
    last_pickup_time,
    baked_breads,
  } = notificationTemplate;

  const selectedBakedBreads = useMemo(
    () => baked_breads.filter((v) => v.selected),
    [baked_breads]
  );

  const isEdit = useMemo(() => id !== "", [id]);

  return (
    <Styled>
      <Item>
        <Label>テンプレート名</Label>
        <Value>{name}</Value>
      </Item>
      <Item>
        <Label>焼き上がりのお知らせ時刻</Label>
        <Value>{formatDate(scheduled_time, "HH:mm")}</Value>
      </Item>
      <Item>
        <Label>通知するパン</Label>
        {selectedBakedBreads.map((bakedBread) => (
          <NotificationTemplateConfirmBakedBread
            key={bakedBread.ref.id}
            bakedBreads={bakedBreads}
            notificationTemplateBakedBread={bakedBread}
          />
        ))}
      </Item>
      <Item>
        <Label>ラストオーダー時刻</Label>
        <Value>{formatDate(can_order_time, "HH:mm")}</Value>
      </Item>
      <Item>
        <Label>最終受取時刻</Label>
        <Value>{formatDate(last_pickup_time, "HH:mm")}</Value>
      </Item>
      <Item>
        <Label>パンの受け渡しに関する注意事項</Label>
        <Value>
          <b>{pickup_supplement}</b>
        </Value>
      </Item>
      <Controller>
        <PrevButtonWrapper>
          <Button
            text="修正する"
            buttonColor="white"
            isDisabled={false}
            clickEvent={onBack}
          />
        </PrevButtonWrapper>
        <NextButtonWrapper>
          <Button
            isDisabled={false}
            clickEvent={() => {
              onSubmit(notificationTemplate);
            }}
            text={`${isEdit ? "保存" : "新規登録"}する`}
          />
        </NextButtonWrapper>
      </Controller>
    </Styled>
  );
};

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M16} 0;
`;
const Item = styled.div`
  &:not(:first-child) {
    margin-top: 32px;
  }
`;
const Label = styled.p`
  font-size: 14px;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  background: ${StyleConfig.COLOR.INPUT_BORDER};
  padding: 9px ${StyleConfig.HELPER.M16};
`;
const Value = styled.p`
  font-size: 16px;
  line-height: ${24 / 16};
  font-weight: bold;
  color: ${StyleConfig.COLOR.TEXT_COLOR};
  padding: 16px ${StyleConfig.HELPER.M16} 0;
`;

const Controller = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${StyleConfig.HELPER.M16};
  margin-top: 52px;
`;
const PrevButtonWrapper = styled.div`
  width: ${(131 / 343) * 100}%;
`;
const NextButtonWrapper = styled.div`
  width: ${(200 / 343) * 100}%;
`;

const mapStateToProps = (state: State) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationTemplateConfirmForm);
